import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { Menu, ViewList } from '@mui/icons-material';
import CustomIconButton from 'components/CustomButtons/IconButton';
import headerStyle from 'components/Header/style/headerStyle';

const s = headerStyle;

const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'color',
})(({ color }) => ({
  ...s.appBar,
  ...(color && s[color]),
}));

const StyledToolbar = styled(Toolbar)(s.container);

const SidebarMinimize = styled('div', {
  shouldForwardProp: (prop) => prop !== 'rtlActive',
})(({ rtlActive }) => ({
  ...s.sidebarMinimize,
  ...(rtlActive && s.sidebarMinimizeRTL),
}));

const SidebarMiniIcon = styled(ViewList)(s.sidebarMiniIcon);

const StyledIconButton = styled(IconButton)(s.appResponsive);

const ResponsiveMenu = styled('div')(s.responsiveMenu);

const BurgerMenu = styled(Menu)(s.burgerMenu);

const Header = ({ color, rtlActive, miniActive, sidebarMinimize, handleDrawerToggle, newHeader }) => {
  return (
    <StyledAppBar color={color}>
      <StyledToolbar disableGutters>
        <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
          <SidebarMinimize rtlActive={rtlActive}>
            {miniActive && (
              <CustomIconButton color="white" onClick={sidebarMinimize}>
                <SidebarMiniIcon />
              </CustomIconButton>
            )}
          </SidebarMinimize>
        </Box>
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          {newHeader ? (
            <ResponsiveMenu>
              <BurgerMenu onClick={handleDrawerToggle} />
              <img
                src={`${__ENV__.PUBLIC_URL}/logo-mobile-header.svg`}
                alt="logo"
                style={{ margin: 'auto', height: '55px' }}
              />
            </ResponsiveMenu>
          ) : (
            <StyledIconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerToggle}
              size="large"
            >
              <Menu />
            </StyledIconButton>
          )}
        </Box>
      </StyledToolbar>
    </StyledAppBar>
  );
};

Header.propTypes = {
  color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
  rtlActive: PropTypes.bool,
  miniActive: PropTypes.bool,
  sidebarMinimize: PropTypes.func,
  handleDrawerToggle: PropTypes.func,
  newHeader: PropTypes.bool,
};

export default Header;